import Base from 'records/Base';
import GlobalParameter from 'records/GlobalParameter';
import {
  GLOBALPARAMETER_UPDATE_ACTION_SUCCESS,
  GLOBALPARAMETER_RESET_STATE,
} from 'actions/globalParameter';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new GlobalParameter(),
});

const actionsMap = {
  [GLOBALPARAMETER_RESET_STATE]: (state, action) => {
    return initialState;
  },

  [GLOBALPARAMETER_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },

};

export default function globalParameter(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
